module.exports = __webpack_public_path__ + "static/media/9.4ccda45e.jpg";